import { StatusPill } from "@playbookai/ui";
import type { KpiReadiness } from "../api/types.js";
import { READINESS_LABEL, READINESS_TONE } from "./kpi-presentation.js";

/** The server-derived readiness headline shared by KPI cards and table rows. */
export function KpiReadinessPill({
  readiness,
}: {
  readiness: KpiReadiness;
}): JSX.Element {
  return (
    <StatusPill tone={READINESS_TONE[readiness]}>
      {READINESS_LABEL[readiness]}
    </StatusPill>
  );
}
